module.exports = __webpack_public_path__ + "static/media/areUSureDelete.b2cb4040.png";